import { createHandlerChainRunnerOptionalParameter, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import setFilterQuery from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetFilterQuery";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import { CustomHandlerWithResult } from "@tLinc/Store/CustomHandlerCreator/CustomHandlerCreator";
import cloneDeep from "lodash/cloneDeep";

type HandlerType = CustomHandlerWithResult<
    {
        removeAll?: true;
    },
    ProductFilters
>;

export const GetCurrentFilters: HandlerType = props => {
    const currentFilters = cloneDeep(props.getState().LINCData.myProductsReducer.productFilters);
    props.result = currentFilters;
};

export const RemoveAllFilters: HandlerType = props => {
    props.result.attributeValueIds = undefined;
    props.result.brandIds = undefined;
    props.result.sort = undefined;
};

export const DispatchSetProductFilters: HandlerType = props => {
    props.dispatch({
        type: "Custom/MyProducts/SetMyProductFilters",
        result: props.result,
    });
};

export const chain = [GetCurrentFilters, RemoveAllFilters, DispatchSetProductFilters];

const customClearAllMyProductFilters = createHandlerChainRunnerOptionalParameter(chain, {}, "ClearAllProductFilters");
export default customClearAllMyProductFilters;
